<template>
  <Transporte />
</template>

<script>
import Transporte from '@/components/drp/configDrpAutomatizado/Transporte.vue';

export default {
  components: { Transporte }
}
</script>
